/* import __COLOCATED_TEMPLATE__ from './info.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();